// packages/api/src/PublicEventReportService.ts
//
// ROADMAP A13.2 — "Report this event": the anonymous write behind the event website's report link. Mirrors
// eventsmagic-api PublicEventCore.reportEvent (stored, and emailed to the PLATFORM — never the host). The reporter is
// told the same thing whatever happened; a refusal comes back field-keyed (url / reason / details / email).
//
// Runs through the injected client (see `configureApiService`) so it works in the BROWSER.
import { gql } from "@apollo/client";
import { OpResult } from "@sdflc/api-helpers";

import { ApiService } from "./ApiService";

/** What a visitor can say is wrong — the server's EVENT_REPORT_REASON, in the drawer's order. */
export const EVENT_REPORT_REASON_OPTIONS = [
  { value: "scam", label: "It's a scam or pretends to be someone else" },
  { value: "spam", label: "It's spam" },
  { value: "offensive", label: "It's offensive or harmful" },
  { value: "other", label: "Something else" },
] as const;

export type EventReportReason = (typeof EVENT_REPORT_REASON_OPTIONS)[number]["value"];

export interface PublicEventReportInput {
  /** The page being reported (host + path). */
  url: string;
  reason: EventReportReason | "";
  details?: string | null;
  email?: string | null;
  visitorId?: string | null;
  /** Honeypot — leave empty; a filled value is silently dropped by the server. */
  website?: string | null;
}

const PUBLIC_EVENT_REPORT_MUTATION = gql`
  mutation PublicEventReport($params: PublicEventReportInput) {
    publicEventReport(params: $params) {
      code
      errors {
        name
        errors
      }
      data {
        ok
        message
      }
    }
  }
`;

export class PublicEventReportService {
  /** Report an event website. Anonymous and rate limited on the server. */
  static async report(input: PublicEventReportInput, options: Record<string, any> = {}): Promise<OpResult> {
    return ApiService.executeMutation(PUBLIC_EVENT_REPORT_MUTATION, { params: input }, options);
  }
}
